<template>
  <div class="center">

      <div class="container">
          <div class="row">
              <div class="jc-demo-box">
                  <div class="page-header">
                  <h1>公考报名照片 在线调整系统</h1>
              </div>

              <div class="upload1">
                <form name="photo" enctype="multipart/form-data" action="" method="post">
                  <input type="text" class="ipt_text" id="file_text">
                  <input type="button" class="btn btnok" value="上传图片">
                  <input type="file" class="upload_file1" name="image" id="image" size="26" accept="image/*" multiple @change="tirggerFile($event)">
                </form>
              </div>

              <div class="">
                  <img  id="yttarget" class="hide"  src=""  />
                  <img  id="target" class="yuantuimg"  src=""  />

                  <div id="preview-pane" v-show="someshow">
                    <div class="preview-container">
                      <img id="yltarget" src="" class="jcrop-preview" alt="Preview" />
                     </div>
                  </div>
              </div>
              <input type="hidden" size="4" id="x" name="x">
              <input type="hidden" size="4" id="y" name="y">
              <input type="hidden" size="4" id="w" name="w">
              <input type="hidden" size="4" id="h" name="h">

              <div class="row">
                  <table border="0" cellspacing="0" cellpadding="0" class="pic_setting_table">
                    <tbody>
                      <tr>
                        <td width="150">选择你需要图片的宽高：</td>
                        <td width="150"><input type="radio" name="cun" value="1" @click="made_set('0')" checked="checked">国考报名尺寸</td>
                        <td><input type="radio" name="cun" value="2" @click="made_set('1')">1寸</td>
                        <td><input type="radio" name="cun" value="3" @click="made_set('2')">2寸</td>
                        <td><input type="radio" name="cun" value="0" @click="self_set()">自己设置</td>
                        <input type="hidden" name="made_width" id="made_width" value="140">
                        <input type="hidden" name="made_height" id="made_height" value="180">
                      </tr>
                       <tr>
                        <td>是否蓝底变红底</td>
                        <td><input type="radio" name="colorred" value="0" @click="color_set('0')" checked="checked">否</td>
                        <td><input type="radio" name="colorred" value="1" @click="color_set('1')">是</td>
                      </tr>
                      <tr>
                        <td>手动输入需要图片宽高：</td>
                        <td>宽：<input name="width" id="width" value="140" type="text" class="pic_set_text" @change="get_val()" disabled="disabled">px</td>
                        <td colspan="3">高：<input name="height" id="height" value="180" @change="get_val()" type="text" class="pic_set_text" disabled="disabled">px</td>
                      </tr>
                    </tbody>
                  </table>
               </div>

              <div class="zindex"  v-show="!someshow">

              </div>

              <div class="row h60 center mt10" v-show="someshow">
                <button id=""  class="btn btnok mt10" @click="submitimg()">确定</button>
              </div>

              <div class="description">
                    <p>
                      <b>本工具能在线修改照片大小及尺寸、照片局部剪切及各类考试的照片</b><br />
                      <b>使用步骤：1、打开网址，上传照片 2、设置所需图片大小 3、拉动选框，选择需截取区域 4、点击保存，生成图片</b><br />
                      <b>国考考生请注意：选择广西、天津、上海、云南等考区的考生，需进入该考区系统，使用官方提供的照片调整软件处理照片方可上传！</b><br />
                    </p>
              </div>

              </div>
          </div>
      </div>



      <div id="showimg" class="hide">
            <p class="pic_xgzs">最终效果图展示</p>
            <div class="pic_box">
              <img id="zuimg" class="yuantuimg" src="" alt="">
            </div>
           <!--  <p class="pic_xx">
              宽：<span>140px</span>
              高：<span>180px</span>
              大小：<span>15.27kb</span>
            </p> -->
            <div class="pic_cz">
                <button id=""  class="btn btnok " @click="loadhref()">再来一张</button>
                <button id=""  class="btn btnok " @click="downloadIamge()">下载</button>
            </div>
      </div>


      <div class="mask" v-show="showmodel">
          <div class="form" >
            <el-form ref="input_user" :model="input_user" :rules="rules" label-width="140px">
              <div class="center">
                <h4>欢迎来到必胜公考</h4>
              </div>

              <el-form-item label="您所在的地区"  prop="province_id">
                  <el-select v-model="input_user.province_id" placeholder="">
                    <el-option  v-for="item in provinceslist" :key="item.province_id" :label="item.province_name" :value="item.province_id"></el-option>
                  </el-select>
                </el-form-item>


              <el-form-item label="您的身份" prop="user_identity">
                <el-radio-group v-model="input_user.user_identity">
                  <el-radio label="0">学生</el-radio>
                  <el-radio label="1">上班族</el-radio>
                  <el-radio label="2">在家备考</el-radio>
                </el-radio-group>
              </el-form-item>



                <el-form-item label="您的考试目标" prop="user_objective">
                  <el-radio-group v-model="input_user.user_objective">
                    <el-radio label="0">国考</el-radio>
                    <el-radio label="1">省考</el-radio>
                  </el-radio-group>
                </el-form-item>


                <el-form-item label="您参加公考的情况" prop="current_situation">
                  <el-radio-group v-model="input_user.current_situation">
                    <el-radio label="0">初次考试</el-radio>
                    <el-radio label="1">去年考过</el-radio>
                    <el-radio label="2">很多次了</el-radio>
                  </el-radio-group>
                </el-form-item>

               <div class="center">
                  <el-button type="primary" @click="jobbankadd">完成</el-button>
               </div>


              </el-form-item>
            </el-form>
          </div>
     </div>


  </div>
</template>

<script>
export default {
  name: 'picturetool',
  data () {
    return {
      someshow:false,
      boundx:'',
      boundy:'',
      imgurl:'',
      xsize:140,
      ysize:180,
      changblue:0,
      showmodel:false,
      input_user: {
          user_identity: '',
          province_id: '',
          user_objective: '',
          current_situation: '',
      },
      provinceslist:[],
      rules: {
          user_identity: [
            { required: true, message: '请选择您的身份', trigger: 'change' },
          ],
          province_id: [
            { required: true, message: '请选择您的地区', trigger: 'change' },
          ],
          user_objective: [
            { required: true, message: '请选择您的考试目标', trigger: 'change' },
          ],
          current_situation: [
            { required: true, message: '请选择您参加公考的情况', trigger: 'change' },
          ],
        }
    }
  },
  computed: {
    current_user() {
      return this.$store.state.user
    }
  },
  created: function() {
    var that=this;
    //获取地区
    that.getprovincelist();
    var user_id=that.current_user.user_id;
    if(user_id || user_id != ''){
      that.pdisjudge();
    }
  },
  methods: {
       //用户初始化信息添加 - ~
      jobbankadd: function () {
        var that=this;
        var user_id=that.current_user.user_id;
        that.$refs.input_user.validate((valid) => {
          if (valid) {
              var url='http://api.web.platform.winlesson.com/api/jobbank/add?user_id='+user_id+"&user_identity="+that.input_user.user_identity+"&province="+that.input_user.province_id+"&user_objective="+that.input_user.user_objective+"&current_situation="+that.input_user.current_situation

               $.ajax({
                  url: url,
                  type: 'POST',
                  cache: false,
                  contentType: false,
                  processData: false,
                  success: function (data) {
                    if (data.code==200) {
                      that.showmodel=false;
                    }
                  },
                  error: function (data) {
                  },

                });
          } else {
            return false;
          }
        });

      },
      //获取地区
      getprovincelist: function () {
         var that=this;

           $.ajax({
              url: 'https://api.web.platform.winlesson.com/api/jobbank/v5/province_list',
              type: 'get',
              cache: false,
              contentType: false,
              processData: false,
              success: function (data) {
                  that.provinceslist = data.result.provinces;
              },
              error: function (data) {
              },

            });
      },
      //用户初始化信息是否填写 - ~
      pdisjudge : function () {
        var that=this;
        var user_id=that.current_user.user_id;
        if (user_id) {
          $.ajax({
              url: 'https://api.web.platform.winlesson.com/api/jobbank/judge?user_id='+user_id,
              type: 'POST',
              cache: false,
              contentType: false,
              processData: false,
              success: function (data) {
                  if (data.code=200) {
                      if (data.is_join=='1') {
                          that.showmodel=false;
                      }
                      else if(data.is_join=='0'){
                        that.showmodel=true;
                      }
                  }
              },
              error: function (data) {
              },

            });
        }

      },
      //上传图片
       tirggerFile : function (event) {
            var that=this;
            var file = event.target.files[0]; // (利用console.log输出看结构就知道如何处理档案资料)
            if (!/image\/\w+/.test(file.type)) {
                //alert("请确保文件为图像类型");
                return false;
            }

            var reader = new FileReader();
            reader.readAsDataURL(file);

            //上传图片
            var formData = new FormData();
            formData.append('image',file);
            $.ajax({
              url: 'https://api.web.platform.winlesson.com/t/upload/image',
              type: 'POST',
              data: formData,
              cache: false,
              contentType: false,
              processData: false,
              success: function (data) {
                  that.imgurl=data.url;
                  $('#target').attr('src',data.url);
                  $('#yltarget').attr('src',data.url);
                  $('#yttarget').attr('src',data.url);



                  $('.upload1').addClass('hide');
                  that.someshow=true;

                  that.startJcrop(1.4,1.8);

                  if (!that.current_user.user_id || that.current_user.user_id == '') {
                       that.$message({
                          message: '请先登录',
                          type: 'warning'
                        });
                      that.$router.push({ path: '/login' })
                      return;
                  }
              },
              error: function (data) {
              },

            });
    },
    startJcrop: function (xsize,ysize) {
            var that=this;
            var jcrop_api;
            var $preview = $('#preview-pane');



              $('#target').Jcrop({//图片剪裁初始化
                  allowSelect:true,  //允许新选框
                  allowMove:true,     //允许选框移动
                  allowResize:true,  //允许选框缩放
                  onChange: that.updatePreview,
                  onSelect: that.updatePreview,
                  aspectRatio: xsize / ysize
                },function(){
                  var api = this;
                  api.setSelect([0,0,140,180]);
                  // Use the API to get the real image size
                  var bounds = this.getBounds();
                  that.boundx = bounds[0];
                  that.boundy = bounds[1];
                  // Store the API in the jcrop_api variable
                  jcrop_api = this;

                  // Move the preview into the jcrop container for css positioning
                  $preview.appendTo(jcrop_api.ui.holder);


                });

    },
    updatePreview: function (c) {//改变选择框事件
          var that=this;
          var $pcnt = $('#preview-pane .preview-container');
          var   $pimg = $('#preview-pane .preview-container img');
          var   xsize = $pcnt.width();
          var   ysize = $pcnt.height();


         if (parseInt(c.w) > 0)
          {
            var rx = xsize / c.w;
            var ry = ysize / c.h;

            $pimg.css({
              width: Math.round(rx * that.boundx) + 'px',
              height: Math.round(ry * that.boundy) + 'px',
              marginLeft: '-' + Math.round(rx * c.x) + 'px',
              marginTop: '-' + Math.round(ry * c.y) + 'px'
            });
          }

           $('#x').val(c.x);
            $('#y').val(c.y);
            $('#w').val(c.w);
            $('#h').val(c.h);
    },
    made_set: function (size) { //国考 1寸 2寸

        var width= 140;
        var height=180;
        var $pcnt = $('#preview-pane .preview-container');

        document.getElementById('width').disabled=true;
        document.getElementById('height').disabled=true;
        if(size=='0'){
           width=140;
           height=180;
           $pcnt.width('140');
           $pcnt.height('180');
            this.xsize='140';
            this.ysize='180';
           this.startJcrop(1.4,1.8);
        }else if(size=='1'){
           width=90;
           height=125;
           $pcnt.width('90');
           $pcnt.height('125');
              this.xsize='90';
            this.ysize='125';
            this.startJcrop(9,12.5);
        }else if(size=='2'){
           width=128;
           height=185;
           $pcnt.width('128');
           $pcnt.height('185');
             this.xsize='128';
            this.ysize='185';
            this.startJcrop(1.28,1.85);
        }
         $('#made_width').val(width);
         $('#made_height').val(height);
         $('#width').val( width);
         $('#height').val(height);

    },
    self_set: function () {
      document.getElementById('width').disabled=false;
      document.getElementById('height').disabled=false;
    },
    get_val: function () {  //自定义宽高
      if(isNaN($('#width').val())){
        alert('您输入的宽不是数字类型');
         $('#width').val(100);
      }else if(isNaN($('#height').val())){
        alert('您输入的高不是数字类型');
         $('#height').val(100);
      }else if( $('#width').val()> 500 || $('#height').val() > 500 ){
        alert('新图的宽高不能超过500*500');
              $('#width').val(100);
            $('#height').val(100);
      }
      var width=  $('#width').val();
      var height= $('#height').val();


      var $pcnt = $('#preview-pane .preview-container');
      $pcnt.width(width);
      $pcnt.height(height);
      this.startJcrop(width,height);
    },
    color_set: function (val) { //红底蓝底
      var that=this;
      that.changblue=val;
    },
    submitimg: function () {
      var that=this;

      var image_url=that.imgurl;
      var blue_to_read=that.changblue;

      var yttargeturl= $('#yttarget').attr('src');
      var img = new Image();
      // 改变图片的src
      img.src = yttargeturl;

      // 打印
      //alert('width:'+img.width+',height:'+img.height);





      var bl= 300/img.width;


      var x=Math.round($('#x').val()/bl);
      var y=Math.round($('#y').val()/bl);
      var w=Math.round($('#w').val()/bl);
      var h=Math.round($('#h').val()/bl);

      var out_width = that.xsize;
      var out_height = that.ysize;

      var url='https://api.web.platform.winlesson.com/api/jobbank/head/image/crop?image_url='+encodeURIComponent(image_url)+"&blue_to_read="+blue_to_read+"&x="+x+"&y="+y+"&w="+w+"&h="+h+"&out_width="+out_width+"&out_height="+out_height;
       $.ajax({
          url: url,
          type: 'POST',
           dataType:'jsonp',
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
              if (data.url) {
                 $('.container').addClass('hide');
                 $('#zuimg').attr('src', data.url);
                 $('#showimg').removeClass('hide');
                 $('#downimg').attr('download', data.url);
                   $('#downimg').attr('href', data.url);
              }

          },
          error: function (data) {
          },

        });

    },
    loadhref: function () {
        window.location.reload();

    },
    downloadIamge: function () {
        // 将图片的src属性作为URL地址
        var src = $("#zuimg").attr('src');
        var $a = document.createElement('a');
          $a.setAttribute("href", src);
          $a.setAttribute("download", "");

          var evObj = document.createEvent('MouseEvents');
          evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, true, false, 0, null);
          $a.dispatchEvent(evObj);
    }
  }
}
</script>


<style scoped>
 @import "../../../static/common/style/jquery.Jcrop.css";
.center{
    display: flex;
     justify-content: center;
}
.upload1 {
    position: relative;
    width: 516px;
    height: 40px;
}
.ipt_text {
    width: 344px;
    height: 38px;
    line-height: 24px;
    margin-right: 4px;
    background: #fbfbfb;
    border: 1px solid #b5b5b5;
    vertical-align: middle;
}
.btn {
    width: 74px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #b5b5b5;
    background: #fbfbfb;
    font-size: 14px;
    vertical-align: middle;
    margin-right: 10px;
    color: #464646;
}
.shc {
    background: #fe625f;
    cursor: pointer;
    width: 80px;
    height: 40px;
    border: none;
    color: #fff;
    vertical-align: middle;
    font-size: 16px;
}
.upload_file1 {
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
    width: 426px;
    height: 38px;
    line-height: 38px;
    opacity: 0;
    filter: alpha(opacity:0);
}
.hide{
  display:none;
}
#preview-pane {
        display: block;
        position: absolute;
        z-index: 2000;
        top: 10px;
        right: -280px;
        padding: 6px;
        border: 1px rgba(0,0,0,.4) solid;
        background-color: white;

        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;

        -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.2);
        box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.2);
      }
#preview-pane .preview-container {
        width: 140px;
        height: 180px;
        overflow: hidden;
      }

      .jc-demo-box {
    text-align: left;
    margin: 2em auto;
    background: white;
    border: 1px ebeef5 solid;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    padding: 1em 2em 2em;
        width: 700px;
}

.yuantuimg{
  max-width:300px;
}
b{
      font-size: 13px;
    color: #606266;
}
.pic_setting_table {
    width: 100%;
    clear: both;
    font-size: 12px;
}
.pic_setting_table td {
    height: 42px;
    border-bottom: 1px dashed #e7e7e7;
    color: #333;
    padding-left: 8px;
}
.pic_setting_table td {
    height: 42px;
    border-bottom: 1px dashed #e7e7e7;
    color: #333;
    padding-left: 8px;
}
.pic_setting_table td input[type="radio"] {
    position: relative;
    top: 2px;
    margin-right: 6px;
}
.pic_set_text{
  width:80px;
}

.jcrop-tracker {
  height: 100%;
  width: 100%;
  /* "turn off" link highlight */
  -webkit-tap-highlight-color: transparent;
  /* disable callout, image save panel */
  -webkit-touch-callout: none;
  /* disable cut copy paste */
  -webkit-user-select: none;
}
.btnok{
      width: 100px;
    border-radius: 5px;
    background: #fab202 !important;
    color: #fff !important;
    border: 0px;
}
.h60{
  height:60px;
}
.mt5{
 margin-top:5px;
}
.mt10{
 margin-top:10px;
}
.pic_xgzs {
    font-size: 16px;
    text-align: center;
    height: 40px;
    margin-top: 57px;
}
.pic_box {
    text-align: center;
}
.pic_xx {
    text-align: center;
    font-size: 14px;
    color: #848484;
    line-height: 58px;
}
.pic_cz {
    text-align: center;
    padding: 32px 0;
}
#showimg{
  flex:1;
}
.mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
}
.mask .form{
    width: 480px;
    padding: 40px;
    margin: auto;
    top: 20%;
    left: 0;
    right: 0;
    border-radius: 5px;
}
.mask > *{
    background: #fff;
    position: absolute;
}
.upload1 input{
-webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.zindex{
    width: 770px;
    height: 300px;
    z-index: 8;
    position: absolute;
    top: 270px;
}

</style>



// WEBPACK FOOTER //
// src/components/smallTool/pictureTool.vue